import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore, $profileStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { cn, RoutePaths } from '@shared/utils';
import { UserOptions } from './widgets';
import { UserInfo, UserInfoHeader } from '@pages/user/widgets';
import { PageContainer } from '@shared/widgets';
import { Addresses } from './widgets/addresses';

export const ProfilePage = () => {
  const { navigate } = useRouteHook();

  const profileStore = useUnit($profileStore.store);
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const { t } = useTranslation('profile');

  useEffect(() => {
    if (!profileFeatureStore.data?.profileSettings.viewProfile) navigate(RoutePaths.dashboard.onNavigate());
  }, []);

  if (!profileFeatureStore.data?.profileSettings.viewProfile) return null;
  if (!profileStore.data) return null;
  return (
    <PageContainer className={cn('flex gap-8', 'max-[1200px]:flex-col')} loading={profileStore.loading} title={t('title')} header={t('header')}>
      <div className='flex flex-1 flex-col gap-8'>
        <UserInfo value={profileStore.data}>
          <UserInfoHeader user={profileStore.data} />
        </UserInfo>
        <Addresses user={profileStore.data} />
      </div>
      <UserOptions />
    </PageContainer>
  );
};
